import { DEFAULT_UNIT_ID_DISPLAY_NAME } from 'src/common/consts/platformConfigConsts';

export const LABEL_PREFIXES = {
	ENVIRONMENT: 'Environment:',
	UNIT_ID: 'unitid:',
	FLOW: 'Flow:'
} as const;

export const FILTER_TYPES = {
	ENVIRONMENT: 'environment',
	UNIT_ID: 'unitId'
} as const;

export type FilterType = (typeof FILTER_TYPES)[keyof typeof FILTER_TYPES];

export const SEARCH_FILTER_LABELS = {
	id: 'searchValue',
	label: 'Search'
} as const;

export const ENVIRONMENT_FILTER_LABELS = {
	id: 'environment',
	label: 'environment',
	componentLabel: 'Environment',
	placeholder: 'Select',
	allSelectedPlaceholder: 'All Environments',
	someItemsSelectedText: (numberOfItems: number) => `Environments (${numberOfItems})`,
	className: 'environment-filter-dropdown'
} as const;

export const UNIT_ID_FILTER_LABELS = {
	id: 'unitId',
	label: 'unitId',
	placeholderPrefix: 'Select',
	allSelectedPrefix: 'All',
	someItemsSelectedPrefix: (unitIdDisplayName: string) => (numberOfItems: number) =>
		`${unitIdDisplayName}s (${numberOfItems})`,
	className: 'unitid-filter-dropdown',
	defaultDisplayName: DEFAULT_UNIT_ID_DISPLAY_NAME
} as const;

export const LABELS_FILTER_LABELS = {
	id: 'labels',
	label: 'custom labels',
	componentLabel: 'custom Labels',
	placeholder: 'Select',
	someItemsSelectedText: (numberOfItems: number) => `Labels (${numberOfItems})`,
	className: 'labels-filter-dropdown'
} as const;

export const PROPERTIES_FILTER_LABELS = {
	id: 'properties',
	label: 'properties',
	componentLabel: 'Property',
	placeholder: 'Select',
	allSelectedPlaceholder: 'All Properties',
	someItemsSelectedText: (numberOfItems: number) => `Properties (${numberOfItems})`,
	className: 'properties-filter-dropdown',
	listboxWidth: '150px'
} as const;

export const TEST_PERIOD_FILTER_LABELS = {
	id: 'testPeriod',
	label: 'tests period',
	componentLabel: 'Test Period',
	placeholder: 'Select'
} as const;
